import { Component, inject, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { HorusMessageGeneralComponent } from "@shared/components/domain/horus-message-general/horus-message-general.component";
import { HorusLoadingComponent } from "@shared/components/domain/horus-loading/horus-loading.component";
import { AvailableDatePipe } from "@shared/pipes/available-date.pipe";
import { ServiceRescheduleState } from "@features/service-actions/store/service-reschedule.state";
import { ServiceRescheduleRequest } from "@features/service-actions/models/service-reschedule.model";
import { HorusBtnDirective } from "../../../../../shared/directives/horus-btn.directive";
import { getAriaTicketUrl } from "app/core/utils/url";

@Component({
  selector: "app-service-reschedule-confirm-dialog",
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    HorusMessageGeneralComponent,
    HorusLoadingComponent,
    AvailableDatePipe,
    HorusBtnDirective,
  ],
  templateUrl: "./confirm-dialog.component.html",
  styleUrl: "./confirm-dialog.component.scss",
})
export class ServiceRescheduleConfirmDialogComponent implements OnDestroy {
  private readonly dialogRef = inject(
    MatDialogRef<ServiceRescheduleConfirmDialogComponent>,
  );
  private readonly dialog = inject(MatDialog);
  readonly serviceRescheduleState = inject(ServiceRescheduleState);
  readonly data = inject<{
    tenantId: string;
    request: ServiceRescheduleRequest;
    serviceId: string;
    serviceItemId: string;
  }>(MAT_DIALOG_DATA);

  confirmReschedule(): void {
    this.serviceRescheduleState.rescheduleServiceMutation.mutate({
      tenantId: this.data.tenantId,
      request: this.data.request,
    });
  }

  retry(): void {
    this.serviceRescheduleState.resetMutationState();
    this.confirmReschedule();
  }

  closeDialog(): void {
    this.serviceRescheduleState.resetMutationState();
    this.dialogRef.close();
  }

  closeAllDialogs(): void {
    this.serviceRescheduleState.resetMutationState();
    this.dialog.closeAll();
  }

  redirectToAria(): void {
    const tenantId = this.data.tenantId;
    const serviceId = this.data.serviceId;

    if (!tenantId || !serviceId) return;

    const url = getAriaTicketUrl(tenantId, serviceId, "SERVICE");
    window.open(url, "_blank");
    this.closeAllDialogs();
  }

  ngOnDestroy(): void {
    this.serviceRescheduleState.resetMutationState();
  }
}
